import { Link, useLocation } from "react-router-dom"
import { logout } from "../../redux/functions/auth"
import routes from "../../constants/routes.const"
import Button from "../buttons/Button"

const Drawer = ({ show, links, onClose }) => {
    const location = useLocation()

    if (!show) return (<></>)

    return (
        <>
            <div className={styles.drawerWrapper}>
                <div className={styles.drawer}>
                    <span onClick={onClose} className={styles.closeBtn}>&times;</span>
                    <div className="m-10" />
                    {
                        links.map((link, i) => {
                            return <Link key={i} to={link.link}>
                                <p className={location.pathname === link.link ? styles.activeNavLink : styles.navLink} >{link.name}</p>
                            </Link>
                        })
                    }
                    <Link to={routes.account}>
                        <p className={location.pathname === routes.account ? styles.activeNavLink : styles.navLink} >Account</p>
                    </Link>
                    <Button label="Logout" action={logout} />
                </div>
            </div>
        </>
    )
}

const styles = {
    drawer: `drawer bg-body p-3 h-screen w-[90vw] fixed right-0 top-0`,
    drawerWrapper: `w-screen h-screen fixed top-0 left-0 bg-[#00000080] z-[600]`,
    navLink: `text-[#fff] m-3 font-medium text-lg`,
    activeNavLink: `text-secondary m-3 font-medium text-lg`,
    closeBtn: `text-5xl absolute right-[10px] hover:opacity-50 cursor-pointer transition-all`,
}

export default Drawer